/**
 * How a CSG slice exposes its solid as data: boolean evaluation needs triangles outside a `<mesh>`,
 * so the slice registers a builder beside its component on the render registry (ADR-0002). A
 * separate registry would let a slice register a component without a builder, which vanishes in a boolean.
 */
import { isClosedBrush } from '../../nodes/3d/csg/brushManifold';
/** The solid of a shaded brush, closed when its welded edges all run both ways. */
export function csgSolid({ geometry, welds }, materials) {
    return { geometry, materials, isClosed: isClosedBrush(welds) };
}
/** Whether `solid` holds a face. A closed solid with none is Godot's empty brush. */
export function hasFaces(solid) {
    return (solid.geometry.getAttribute('position')?.count ?? 0) > 0;
}
/**
 * A `CSGPrimitive3D`'s solid: one geometry under its one `material`. Box, sphere, cylinder and
 * torus builders emit a closed brush by construction, which `primitiveBrushes.test.ts` pins, so
 * this skips the weld that `csgSolid` runs.
 */
export function primitiveSolid(geometry, properties) {
    return { geometry, materials: [properties.materialPath], isClosed: true };
}
//# sourceMappingURL=csgRegistration.js.map